import type { CustomMessageMiniEntity } from "./CustomMessageMiniEntity"

export class CustomMessagesResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<CustomMessageMiniEntity> | null
}
